import React from "react";
import Head from "next/head";

import PropertyDocuments from "components/PropertyDocuments";

import { useFormattedMessage } from "hooks";
import { siVermoeGen1 } from "i18n/messages/meta";
import { getDocumentsHost } from "common/helper";
import { TENANTS_LIST } from "constants/index";

const DOCUMENT_HOST = getDocumentsHost();

const SIVermoeGen1DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen",
        path: `${DOCUMENT_HOST}/docs/general/si/vermoegen1/SACHWERT01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 02/2022 - PDF - 423 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)*",
        path: `${DOCUMENT_HOST}/docs/general/si/vermoegen1/SACHWERT01_Basisinformationsblatt.pdf`,
        description: "Stand 02/2022 - PDF - 120 KB",
    },
    {
        title: "Verlängerung Angebotszeitraum Stern! Kindergarten & Wohnen SACHWERT-01",
        path: `${DOCUMENT_HOST}/docs/general/si/vermoegen1/SACHWERT01_Verlaengerung_Angebotszeitraum_SWI_01_Token.pdf`,
        description: "Stand 07/2021 - PDF - 238 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)*",
        path: `${DOCUMENT_HOST}/docs/general/si/vermoegen1/SACHWERT01_Basisinformationsblatt_2023.pdf`,
        description: "Stand 01/2023 - PDF - 120 KB",
    },
];

const SIVermoeGen1 = () => {
    const { formatMessage } = useFormattedMessage();

    return (
        <>
            <Head>
                <title>{formatMessage(siVermoeGen1.title)}</title>
                <meta name="description" content="SI Vermögen 1 GmbH" />
            </Head>
            <div className="broad-container issuer-public-page">
                <section className="banner-section" style={{ backgroundImage: "url(/images/si-vermoegen1.jpg)" }} />
                <section className="content-section small-container">
                    <div className="header-part">
                        <div className="logo-container shadow border-radius">
                            <img src={"/images/logo-siVermoegen1.png"} alt="" />
                        </div>
                        <p>
                            Der Unternehmensgegenstand der Gesellschaft besteht in dem Erwerb, dem Halten und Verwalten von
                            Grundstücken (die "Immobilie(n)").
                        </p>
                    </div>
                    <div className="border-x" />
                    <div className="content-part">
                        <h2>SI Vermögen 1 GmbH</h2>
                        <p>Bei der Finanzierung verfolgt die SI Vermögen 1 GmbH eine langfristig ausgerichtete Strategie.</p>
                    </div>
                    <div className="two-parts">
                        <div className="first-part">
                            <div className="pdf-part">
                                <h3>Kapitalmarktdokumentation</h3>
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={SIVermoeGen1DocumentsData} />
                                <span className="bottom-line text-14 d-block">
                                    *Basisinformationsblatt gemäß EU-Verordnung 1286/2014
                                </span>
                            </div>
                        </div>
                        <div className="second-part">
                            <h3>Kontakt</h3>
                            <p>
                                Bei Fragen zu den tokenisierten Schuldverschreibungen sind wir persönlich erreichbar über die
                                E-Mail-Adresse:
                                <br />
                                <a href="mailto:si-vermoegen1@sachwertinvest.de">si-vermoegen1@sachwertinvest.de</a>
                            </p>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

SIVermoeGen1.getInitialProps = async ({ res, req, isServer }) => {
    if (req?.tenant !== TENANTS_LIST.SACHWERTINVEST) res.redirect("/404");
    return { isServer };
};

export default SIVermoeGen1;
